module.exports = __webpack_public_path__ + "static/media/2.a8b39f4a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/2.mp3
// module id = 53
// module chunks = 0